import { render, staticRenderFns } from "./apppurchased.vue?vue&type=template&id=e6bb77c2&"
import script from "./apppurchased.vue?vue&type=script&lang=js&"
export * from "./apppurchased.vue?vue&type=script&lang=js&"
import style0 from "./apppurchased.vue?vue&type=style&index=0&id=e6bb77c2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports